var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('keep-alive',{attrs:{"exclude":"hotelBook"}},[_c('router-view',{key:_vm.$route.fullPath})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }